import { createRoute } from "@tanstack/react-router";

import { OpsContent } from "../components/screens/OpsContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/ops",
  component: OpsContent,
});
